// dateUtils.js
export function formatTo12Hour_OLD(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Add 1 to month (0-indexed)
  const day = String(date.getDate()).padStart(2, '0');
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';

  // Convert hours to 12-hour format
  hours = hours % 12 || 12; // If hour is 0, set to 12 (midnight or noon)

  return `${year}-${month}-${day} ${String(hours).padStart(2, '0')}:${minutes}:${seconds}`;
}

export function formatTo12Hour(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Add 1 to month (0-indexed)
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0'); // Keep 24-hour format
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export function subtractTime(date, options = {}) {
  const { minutes = 0, hours = 0, days = 0 } = options;

  return new Date(
    date.getTime() -
    (minutes * 60 * 1000 + hours * 60 * 60 * 1000 + days * 24 * 60 * 60 * 1000)
  );
}

export function dateFormat(inputDate) {
  const date = typeof inputDate === "string" ? new Date(inputDate.replace(" ", "T")) : new Date(inputDate);

  // Extract parts of the date
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  // Combine parts into the desired format
  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;

}